export const VIEW_URL = 'view';

export const WIDGET_URL = 'performance/widget';

export const DSP_WIDGET_URL = 'performance/dsp-widget';

export const BUDGET_URL = 'performance/widget-budget';

export const DSP_BUDGET_URL = 'performance/dsp-widget-budget';

export const NESTED_ANALYTICS_URL = 'performance/nested-analytics';

export const DSP_NESTED_ANALYTICS_URL = 'performance/dsp-nested-analytics';

export const CHART_URL = 'performance/chart';

export const DSP_CHART_URL = 'performance/dsp-chart';

export const INCREMENTALITY_URL = 'performance/incrementality';

export const HALO_URL = 'performance/halo';

export const ADFORM_HALO_URL = 'performance/adform-halo';

export const FREEWHEEL_HALO_URL = 'performance/freewheel-halo';

export const ADFORM_INCREMENTALITY_URL = 'performance/adform-incrementality';

export const FREEWHEEL_INCREMENTALITY_URL = 'performance/freewheel-incrementality';

export const ANALYTICS_URL = 'performance/analytics';

export const DSP_ANALYTICS_URL = 'performance/dsp-analytics';

export const ANALYTICS_DOWNLOAD_URL = 'performance/analytics-download';

export const DSP_ANALYTICS_DOWNLOAD_URL = 'performance/dsp-analytics-download';

export const ALL_TOUCH_URL = 'performance/all-touch';

export const ADFORM_ALL_TOUCH_URL = 'performance/adform-all-touch';

export const CREATIVE_URL = 'creative';

export const CREATIVE_NAMES_URL = 'creative/names';

export const PUBLISHER_URL = 'publisher';

export const SPEND_BUDGET_METRIC = 'SPEND';

export const COST_BUDGET_METRIC = 'COST';

export const CAMPAIGN_DIMENSION = 'CAMPAIGN';

export const DAILY_CADENCE = 'DAILY';

export const REACH_METRIC = 'REACH';

export const FREQUENCY_METRIC = 'FREQUENCY';
